export const filterHeader = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderBottom: '1px solid lightgray'
}

export const filterCard = {
  margin: '1rem 0',
  padding: '0 1rem',
  borderRadius: '8px',
  backgroundColor: '#F2F3F3'
}

export const CardHeader = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
}

export const saveFilterHeader = {
  display: 'flex',
  justifyContent: 'space-between',
  position: 'absolute',
  right: '-20px',
  top: '-20px'
}

export const container = {
  position: 'relative'
}

export const saveFilterLabel = {
  display: 'flex',
  alignItems: 'center',
  marginTop: '16px',
  marginBottom: '8px',
  gap: '16px',
  padding: '0 1rem',
}

export const dropdownLabel = {
  fontSize: '0.875rem',
  fontWeight: 600,
  color: '#374151',
  minWidth: '140px',
  margin: 0,
}

export const dropdownContainer = {
  minWidth: '200px',
  '& .MuiOutlinedInput-root': {
    fontSize: '0.875rem',
    backgroundColor: 'white',
    borderRadius: '8px',
    '& fieldset': {
      borderColor: '#d1d5db',
      borderWidth: '1px',
    },
    '&:hover fieldset': {
      borderColor: '#9ca3af',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#367598',
      borderWidth: '2px',
    },
  },
  '& .MuiInputLabel-root': {
    fontSize: '0.875rem',
    color: '#6b7280',
    '&.Mui-focused': {
      color: '#367598',
    },
  },
  '& .MuiSelect-select': {
    padding: '8px 14px',
    fontSize: '0.875rem',
    color: '#111827',
  },
}

export const menuItemStyle = {
  fontSize: '0.875rem',
  padding: '8px 16px',
  '&:hover': {
    backgroundColor: '#f3f4f6',
  },
  '&.Mui-selected': {
    backgroundColor: '#e0f2fe',
    color: '#0369a1',
    '&:hover': {
      backgroundColor: '#bae6fd',
    },
  },
}
